// eslint-disable-next-line import/no-anonymous-default-export
export default {
  baseURL:    process.env.REACT_APP_API,
  appURL:     process.env.REACT_APP_URL,
  storageURL: process.env.REACT_APP_STORAGE,
};